import React from "react";
import "../accountingPackage/pricing.css";

const ContactSuggestion = () => (
  <section className="thas-pricing-custom" aria-labelledby="custom-pricing-heading">
    <div className="thas-pricing-container">
      <div className="thas-pricing-custom-panel">
        <div>
          <p className="thas-pricing-eyebrow">Ett upplägg för din verksamhet</p>
          <h2 id="custom-pricing-heading">Fler än 40 verifikationer per månad?</h2>
          <p>Vi hjälper dig med en kostnadsfri offert anpassad efter dina behov.</p>
        </div>
        <a className="thas-pricing-link thas-pricing-link-light" href="/#contact">
          Be om en offert
          <span aria-hidden="true">↗</span>
        </a>
      </div>
    </div>
  </section>
);

export default ContactSuggestion;
